import { useState, useRef } from 'react';
import { isEmpty } from "lodash";
import { getFormattedLoadingGuideData } from './utils';
import appConstants from '../../../../../appConstants';
import {
  getSpecialNeedsOptionsWithServiceLevel,
  getGridFeatureFlagsByGridNames
} from '../../../utils';

const usePrintLoadingGuideData = (
  IBPlanningStore,
  columnConfig,
  getSelectedRoutes,
  userProfile,
  enqueueSnackbar,
  configJSON
) => {
  const [printData, setPrintData] = useState([]);
  const printOrientation = useRef('portrait'); // Default to portrait for all clients

  const preparePrintData = (loadingGuideConfig) => {
    const selectedRoutes = getSelectedRoutes?.();
    const specialNeedsOptions = getSpecialNeedsOptionsWithServiceLevel(
      IBPlanningStore.serviceLevelList
    );
    const formattedData = getFormattedLoadingGuideData({
      loadingGuideConfig,
      columnConfig,
      selectedRoutes,
      shipments: IBPlanningStore.filteredRouteShipments.slice(),
      specialNeedsOptions,
      userProfile
    });
    
    // Extract orientation if it exists in the config
    if (loadingGuideConfig.printSetting?.orientation) {
      printOrientation.current = loadingGuideConfig.printSetting.orientation;
    }
    
    setPrintData(formattedData);
  };

  const getLoadingGuideConfig = () => {
    const loadingGuideConfig = getGridFeatureFlagsByGridNames(
      configJSON?.gridConfiguration,
      appConstants.gridNames.LoadingGuide
    );
    if (isEmpty(loadingGuideConfig)) {
      enqueueSnackbar('Loading Guide configuration not found', { variant: 'error' });
      return;
    }
    return JSON.parse(loadingGuideConfig);
  };

  const fetchAndPrepareData = () => {
    const loadingGuideConfig = getLoadingGuideConfig();
    if (loadingGuideConfig) {
      preparePrintData(loadingGuideConfig);
    }
  };

  const resetPrintData = () => {
    setPrintData([]);
  };

  return { printData, fetchAndPrepareData, resetPrintData, printOrientation };
};

export default usePrintLoadingGuideData;
